import { isEmpty } from 'lodash'
import React, { FunctionComponent, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { OnDemandGallery } from '../../components/OnDemandGallery'
import { CurrentUserType } from '../../ducks/auth'
import Amplitude from '../../utils/amplitudeHelper'
import { useWindowSize } from '../../utils/useWindowSize'
import { OnDemandStyle } from './styled'
import { fixedAssets } from 'src/containers/PreCache'

interface MobileOnDemandTypes {
  currentUser: CurrentUserType
}

const MobileOnDemand: FunctionComponent<MobileOnDemandTypes> = ({ currentUser }) => {
  const history = useHistory()
  const { pageTitle, previousPagePath } = useSelector((state) => state.onDemand)
  const { windowHeight } = useWindowSize()

  useEffect(() => {
    if (pageTitle.length > 0) Amplitude.visit(pageTitle)
  }, [currentUser.id, pageTitle])

  const goBack = () => {
    if (isEmpty(previousPagePath)) {
      history.goBack()
    } else {
      history.push(previousPagePath)
    }
  }

  return (
    <OnDemandStyle mobileHeight={windowHeight}>
      <img src={fixedAssets.headerBanner} width="100%" className="mx-auto d-block" alt="event visual" />
      <div className='backBtn' onClick={goBack}>
        <svg width="23.81" height="6.985" viewBox="0 0 23.81 6.985">
          <g transform="translate(1.06 1.06)">
            <path d="M699.175,759H677.491" transform="translate(-677.175 -754)" fill="none" stroke="#2f2651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
            <path d="M716.5,746.126l-5.294,4.866" transform="translate(-711.207 -746.126)" fill="none" stroke="#2f2651" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
          </g>
        </svg>
        <small>Back</small>
      </div>
      <main className='shadow'>
        <h4 className='title'>{pageTitle}</h4>
        <OnDemandGallery />
      </main>
      {/* <div className="page-layout">
        <div className="page-content">
          <button onClick={goBack} className="back-btn">
            <div className="back-icon">
              <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                <g transform="translate(17.301 26.839) rotate(180)">
                  <path
                    d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z"
                    transform="translate(17.301 26.839) rotate(180)"
                    fill="#F85D49"
                  />
                </g>
              </svg>
              <small className="icon-label">Back</small>
            </div>
            <span>{pageTitle}</span>
          </button>
          <OnDemandGallery />
        </div>
      </div> */}
    </OnDemandStyle>
  )
}

export default MobileOnDemand
